// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__zDe8i","errorTitle":"Error_errorTitle__Mozwy","text404":"Error_text404__g2A6L","linkHome":"Error_linkHome__f4m9C"};